import React from "react";
import Icofont from "react-icofont";
import ReactWOW from "react-wow";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 120,
    display: "flex",
    alignItems: "flex-start",
    marginBottom: 50,
    flexDirection: "row",
    gap: theme.spacing(2),
  },
  iconWrapper: {
    flexShrink: 0,
    width: 60,
    height: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    fontSize: 50,
    color: theme.palette.text.primary,
  },
  content: {
    flexGrow: 1,
  },
  title: {
    marginTop: 0,
    fontWeight: "bold",
  },
  text: {
    fontSize: "0.9rem",
    marginTop: theme.spacing(0.5),
  },
  whiteColor: {
    color: "#fff",
  },
}));

const FeatureBox = ({ icon, iconColor, title, color, children }) => {
  const classes = useStyles();

  return (
    <ReactWOW animation="fadeTop" delay="0.1s">
      <div
        className={classes.root}
        style={color === "white" ? { color: "#fff" } : undefined}
      >
        <div className={classes.iconWrapper}>
          <Icofont icon={icon} className={classes.icon} style={{ color: iconColor || "inherit" }}/>
        </div>
        <div className={classes.content}>
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>
          <Typography className={classes.text}>{children}</Typography>
        </div>
      </div>
    </ReactWOW>
  );
};

export default FeatureBox;